import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@chakra-ui/react';

import { selectCurrentAutomation } from '../../../../../../redux/modules/emailAutomations';
import { showModal } from '../../../../../../redux/modules/modal';
import { tryFormatDate } from '../../../../../../utils/dateUtil';
import SequenceDetails from '../../SequenceDetails';

const CurrentStepCell = ({ value }) => {
  const dispatch = useDispatch();
  const automation = useSelector(selectCurrentAutomation);
  const automationEmail = value.emails[0];

  if (!automationEmail) {
    return 'Something went wrong. No email found.';
  }

  const stepName = automation.steps.find(s => automationEmail.stepId === s.id)?.name;

  const openInfoModal = () => {
    dispatch(showModal(SequenceDetails, { title: 'Sequence Details', size: null, maxW: '1000px' }, { sequence: value, automation }));
  };

  return (
    <Button display="block" textAlign="right" variant="link" onClick={openInfoModal}>
      <Box>{tryFormatDate(automationEmail.createdAt)}</Box>
      <Box>{stepName}</Box>
    </Button>
  );
};

export default CurrentStepCell;
